








import { Prop, Component, Vue } from "vue-property-decorator";
import VGridCell from "../../../components/VGridCell.vue";

@Component({
  components: {
    VGridCell
  }
})
export default class ScheduleCell extends Vue {
  @Prop({ required: true }) icon!: string;
  @Prop({ default: "" }) variant!: string;

  get className() {
    if (!this.variant) return "";
    return `schedule-cell-${this.variant}`;
  }
}
